import * as ReactDOM from 'react-dom/client';

import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './app/app';
import { BookingGateway } from './infra/adapters/luminara/booking/booking-gateway';
import { CalendarGateway } from './infra/adapters/luminara/calendar/calendar-gateway';
import ClientBookingStockGateway from './infra/adapters/luminara/client-booking-stock/client-booking-stock-gateway';
import ClientInfoGateway from './infra/adapters/luminara/client-info/client-info-gateway';
import { ClientGateway } from './infra/adapters/luminara/client/client-gateway';
import HealerBankDetailsGateway from './infra/adapters/luminara/healer-bank-details/bank-details-gateway';
import { HealerFeedbackGateway } from './infra/adapters/luminara/healer-feedback/healer-feedback-gateway';
import HealerInfoGateway from './infra/adapters/luminara/healer-info/healer-info-gateway';
import { HealerPackageGateway } from './infra/adapters/luminara/healer-package/healer-package-gateway';
import { HealerSelectionGateway } from './infra/adapters/luminara/healer-selection/healer-selection-gateway';
import { PaymentGateway } from './infra/adapters/luminara/payment/payment-gateway';
import { ProfilePreviewFeedbackGateway } from './infra/adapters/luminara/profile-preview-feedback/profile-preview-feedback-gateway';
import { SessionTypeGateway } from './infra/adapters/luminara/session-type/session-type-gateway';
import { SoundtrackGateway } from './infra/adapters/luminara/soundtrack/soundtrack-gateway';
import ClientUserProfileGateway from './infra/adapters/luminara/userprofile/client-user-profile-gateway';
import HealerUserProfileGateway from './infra/adapters/luminara/userprofile/healer-user-profile-gateway';
import { Auth0ProviderWithNavigate } from './infra/auth/auth0-provider';
import { PosthogFeatureFlagsProvider } from './infra/feature-flags/posthog/posthog-feature-flags-provider';
import { configAppStore } from './store/store';
import { RequestNewHealerGateway } from './infra/adapters/luminara/request-new-healer/request-new-healer-gateway';
import { MySelectionsGateway } from './infra/adapters/luminara/my-selections/my-selection-gateway';
import ClientSessionFeedbackGateway from './infra/adapters/luminara/client-session-feedback/client-session-feedback-gateway';
import { GTM_ID } from './constants/app-constants';
import TagManager from 'react-gtm-module';

if (GTM_ID) {
  const tagManagerArgs = {
    gtmId: GTM_ID,
  };
  TagManager.initialize(tagManagerArgs);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const clientGateway = new ClientGateway();
const bookingGateway = new BookingGateway();
const soundtrackGateway = new SoundtrackGateway();
const userProfileGateway = new HealerUserProfileGateway();
const clientUserProfileGateway = new ClientUserProfileGateway();
const healerFeedbackGateway = new HealerFeedbackGateway();
const calendarGateway = new CalendarGateway();
const paymentGateway = new PaymentGateway();
const healerSelectionGateway = new HealerSelectionGateway();
const mySelectionsGateway = new MySelectionsGateway();
const healerPackageGateway = new HealerPackageGateway();
const sessionTypeGateway = new SessionTypeGateway();
const clientInfoGateway = new ClientInfoGateway();
const healerInfoGateway = new HealerInfoGateway();
const clientBookingStockGateway = new ClientBookingStockGateway();
const profilePreviewFeedbackGateway = new ProfilePreviewFeedbackGateway();
const healerBankDetailsGateway = new HealerBankDetailsGateway();
const requestNewHealerGateway = new RequestNewHealerGateway();
const clientSessionFeedbackGateway = new ClientSessionFeedbackGateway();
const store = configAppStore({
  clientGateway,
  bookingGateway,
  soundtrackGateway,
  userProfileGateway,
  clientUserProfileGateway,
  healerFeedbackGateway,
  calendarGateway,
  paymentGateway,
  healerSelectionGateway,
  mySelectionsGateway,
  healerPackageGateway,
  sessionTypeGateway,
  clientInfoGateway,
  healerInfoGateway,
  clientBookingStockGateway,
  profilePreviewFeedbackGateway,
  healerBankDetailsGateway,
  requestNewHealerGateway,
  clientSessionFeedbackGateway,
});

root.render(
  <BrowserRouter>
    <Auth0ProviderWithNavigate>
      <Provider store={store}>
        <PosthogFeatureFlagsProvider>
          <App />
        </PosthogFeatureFlagsProvider>
      </Provider>
    </Auth0ProviderWithNavigate>
  </BrowserRouter>
);
